// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__OiyGW","left":"StickyBox_left__1W0-M","right":"StickyBox_right__VMJj6"};